import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OverlayModule } from '@angular/cdk/overlay';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';

import { SharedModule } from 'src/app/common/modules/shared/shared.module';
import { MatSidenavModule } from '@angular/material/sidenav';
import { DealerMenuComponent } from '../common/dealer-menu/dealer-menu.component';
import { DealerRentInRoutingModule } from './dealer-rent-in.routing';
import { DealerRentInComponent } from './dealer-rent-in.component';


@NgModule({
  declarations: [
    DealerRentInComponent,
  ],
  
  imports: [
    CommonModule,
    DealerRentInRoutingModule,

    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    MatDialogModule,
    MatButtonModule,
    
    MatCardModule,
    MatGridListModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatExpansionModule,
    MatListModule,
    MatSidenavModule,
    
    OverlayModule,

    SharedModule,

    DealerMenuComponent
    
  ]
})
export class DealerRentInModule { }
